import { MoveItemLaneRequest } from "./MoveLaneRequest"

export interface DocumentPermissionsRequest {
    isLimitedToMembers: boolean
    isPrivate: boolean
    groupUid: string | null
    laneId?: number | null
    moveLaneRequest?: MoveItemLaneRequest
}

export interface LocalDocumentPermissionsRequest {
    isLimitedToMembers?: boolean
    isPrivate?: boolean
    groupUid?: string | null
    CurrentStatus?: string | null
    currentStatus?: string | null
    TaskStatusColor?: number | null
    taskStatusColor?: number | null
}

export const getPrivateDocumentPermission = (): DocumentPermissionsRequest => ({
    isPrivate: true,
    isLimitedToMembers: false,
    groupUid: null
})

export const getPublicDocumentPermission = (): DocumentPermissionsRequest => ({
    isPrivate: false,
    isLimitedToMembers: false,
    groupUid: null
})

export const getLimitedDocumentPermission = (): DocumentPermissionsRequest => ({
    isPrivate: true,
    isLimitedToMembers: true,
    groupUid: null
})

export const getGroupDocumentPermission = (groupUid: string): DocumentPermissionsRequest => ({
    groupUid,
    isLimitedToMembers: false,
    isPrivate: false
})